import React, {useEffect} from 'react';
import {useLocation, useParams} from "react-router-dom";
import {useDispatch} from "react-redux";
import Home from "./Home";
import {withCookieChecker} from "../common";

import styles from './HomeContainer.module.scss';

export const HomeContainer = (props) => {
  const dispatch = useDispatch();
  const {pathname} = useLocation();
  const {error = false, request} = useParams();

  useEffect(() => {
    if (error) {
      dispatch.newRequest.handlerExternalError({error, request});
      return;
    }

    if (pathname?.includes('satisfactoryPayment')) {
      dispatch.newRequest.satisfactoryPayment({error, request});
    }
  }, [error, request, dispatch, pathname]);

  return <Home {...props}/>;
};

HomeContainer.propTypes = {}

HomeContainer.defaultProps = {}

export default withCookieChecker(HomeContainer, {className: styles.cookieContainer});
